import { FC } from "react";
import { UseFormGetValues } from "react-hook-form";
import { INSURANCE_TYPE } from "src/constants/cases";
import { formatPhoneNumber } from "src/helpers";
import { AddCaseProps, InsuranceAttributesProps } from "src/pages/addCase/types";
interface InsuranceProps {
  id: number;
  insurance: InsuranceAttributesProps;
  drugName: string;
  getValues: UseFormGetValues<AddCaseProps>;
}
const ShowInsuranceInformation: FC<InsuranceProps> = ({ id, insurance, drugName, getValues }): JSX.Element => {
    const {  prescription_attributes } = getValues();

  return (
    <div className="card my-3 px-0">
     <div className="m-3"> 
      {prescription_attributes.drug_name === "zilretta" &&
        <div className="row align-items-center">
          <div className="col-10 px-3 d-flex justify-content-center align-items-center">
            <span className="fw-bold">
              Is the patient enrolled in a federal- or state-funded healthcare program
              such as Medicare, Medicare Advantage, Medicaid, VA, DoD, TRICARE, a
              qualified health plan (QHP), or any other federal or state healthcare
              plan or a pharmaceutical assistance program?
            </span>
            <span>:</span>
          </div>
          <div className="col-2 text-start">
            {typeof getValues("patient_attributes.is_enrolled_in_federal") === "boolean" ? 
              getValues("patient_attributes.is_enrolled_in_federal") ? "Yes" : "No"
              : "N/A"
            }
          </div>
        </div>
      }
       </div>
      <div className={`card-header ${drugName === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">
          Insurance # {id}: {insurance && insurance.insurance_name ? insurance.insurance_name : 'N/A'}
        </h4>
      </div>


      <div className="card-body">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Insurance Type:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.plan_type ?
                  INSURANCE_TYPE.find((ins_type) => ins_type.value === insurance.plan_type)?.label
                  : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Relationship to patient:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.relation_to_patient ? insurance.relation_to_patient : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>

        {insurance.relation_to_patient !== "self" ? (
          <>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6 px-3">
                    <label className="form-label">Relative First Name:</label>
                  </div>
                  <div className="col-6">
                    <p>{insurance && insurance.relation_firstname ? insurance.relation_firstname : 'N/A'}</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6 px-3">
                    <label className="form-label">Relative Middle Name:</label>
                  </div>
                  <div className="col-6">
                    <p>{insurance && insurance.relation_middlename ? insurance.relation_middlename : 'N/A'}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row p-2">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="row">
                  <div className="col-6 px-3">
                    <label className="form-label">Relative Last Name:</label>
                  </div>
                  <div className="col-6">
                    <p>{insurance && insurance.relation_lastname ? insurance.relation_lastname : 'N/A'}</p>
                  </div>

                </div>
              </div>
            </div>
          </>
        ) : null}

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Member ID:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.policy ? insurance.policy : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Group:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.group_number ? insurance.group_number : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Phone:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.insurance_number ? formatPhoneNumber(insurance.insurance_number) : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>

       {!(drugName?.includes('iovera')) && 
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 px-3">
                <label className="form-label">Rx Member ID:</label>
              </div>
              <div className="col-6">
                <p>{insurance && insurance.member_id ? insurance.member_id : 'N/A'}</p>
              </div>
            </div>
          </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="row">
                <div className="col-6 px-3">
                  <label className="form-label">Rx Group:</label>
                </div>
                <div className="col-6">
                  <p>{insurance && insurance.rx_group ? insurance.rx_group : 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
        }

        {!(drugName?.includes('iovera')) && 
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="row">
                <div className="col-6 px-3">
                  <label className="form-label">PCN #:</label>
                </div>
                <div className="col-6">
                  <p>{insurance && insurance.pcn ? insurance.pcn : 'N/A'}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="row">
                <div className="col-6 px-3">
                  <label className="form-label">BIN #:</label>
                </div>
                <div className="col-6">
                  <p>{insurance && insurance.bin ? insurance.bin : 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>
          }
      </div>
    </div>
  );
};

export default ShowInsuranceInformation;
